import {remCalc} from '../_utils'

const iconsSize = {
    small: remCalc(16),
    medium: remCalc(24),
    large: remCalc(32),
    xlarge: remCalc(40),
}

export default iconsSize
